export const WHITE = '#ffffff';
export const LIGHT_GRAY_COLOR = '#dddddd';
export const LIGHTER_GRAY_COLOR = '#eeeeee';
export const CIO_PURPLE = '#7131FF';
export const LIGHT_CIO_GREEN = '#a0cac9';
export const LIGHTER_CIO_GREEN = '#9fc5c1';
export const COLOR_TEXT = '#545D63'; // $color-text-default from fly-css-framework
export const COLOR_TEXT_DARK = '#2F3437'; // $color-text-dark from fly-css-framework
export const COLOR_TEXT_MUTED = '#909AA1'; // $color-text-light from fly-css-framework

export const CYAN = '#00626E';
export const BLUE = '#151630';
export const VIOLET = '#3532C2';
export const TEAL = '#007056';
export const YELLOW = '#8F6F00';
export const ORANGE = '#904405';
export const PINK = '#7F003D';
export const PURPLE = '#4F2D73';
export const PURPLE_LIGHT = '#A569b1';
export const DANGER_STATE = '#e60134';
export const DANGER_RED = '#a94442';
export const DANGER_RED_LIGHT = '#d9534f';
export const DANGER_RED_LIGHTER = '#ed8d85';

// Purple
export const PURPLE_900 = '#331673';
export const PURPLE_700 = '#5721CC';
export const PURPLE_500 = '#7131FF';
export const PURPLE_300 = '#BA9CFF';
export const PURPLE_100 = '#F1EAFF';

// Plum
export const PLUM_900 = '#5C1E8F';
export const PLUM_700 = '#834BBF';
export const PLUM_500 = '#AF64FF';
export const PLUM_300 = '#E1C9FF';
export const PLUM_100 = '#F5F0FF';

// Ink
export const INK_900 = '#2F326A';
export const INK_700 = '#484B7D';
export const INK_500 = '#6D6E97';
export const INK_300 = '#DFDFF2';
export const INK_100 = '#F2F2FF';

// Gray
export const GRAY_900 = '#343446';
export const GRAY_700 = '#4B4B60';
export const GRAY_500 = '#6F7488';
export const GRAY_400 = '#A1A2B2';
export const GRAY_300 = '#C7C7D4';
export const GRAY_200 = '#EBECF2';
export const GRAY_100 = '#F7F8FA';

// Yellow
export const YELLOW_900 = '#8C6E00';
export const YELLOW_700 = '#C79F00';
export const YELLOW_500 = '#FFCD00';
export const YELLOW_300 = '#FFEB99';
export const YELLOW_100 = '#FFFAE5';

// Red
export const RED_900 = '#69002C';
export const RED_700 = '#AB0937';
export const RED_500 = '#DB234B';
export const RED_300 = '#FF9CAE';
export const RED_100 = '#FFEDF0';

// Green
export const GREEN_900 = '#156352';
export const GREEN_500 = '#21C496';
export const GREEN_300 = '#99F0D4';
export const GREEN_100 = '#E6FAF3';

// Teal
export const TEAL_900 = '#007069';
export const TEAL_700 = '#00AB9A';
export const TEAL_500 = '#00F8BF';
export const TEAL_300 = '#80FCDF';
export const TEAL_100 = '#E5FEF9';

// Blue
export const BLUE_900 = '#055666';
export const BLUE_700 = '#0597AD';
export const BLUE_500 = '#00D9F5';
export const BLUE_300 = '#80ECFA';
export const BLUE_100 = '#E5FBFE';

// Raspberry
export const RASPBERRY_900 = '#87004D';
export const RASPBERRY_700 = '#B80062';
export const RASPBERRY_500 = '#EB0075';
export const RASPBERRY_300 = '#FFB5CC';
export const RASPBERRY_100 = '#FFF2F8';

// Clementine
export const CLEMENTINE_900 = '#914201';
export const CLEMENTINE_700 = '#C45C0C';
export const CLEMENTINE_500 = '#F7751E';
export const CLEMENTINE_300 = '#FFC48C';
export const CLEMENTINE_100 = '#FFF0E8';